import { Button, Dropdown } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import React, { useState } from 'react';
import { TbCirclesRelation, TbLogin, TbLogout, TbUserCircle } from 'react-icons/tb';
import { useLocation } from 'react-router-dom';

import { actions } from '~/redux/auth/slice';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';

export default function LoginButton(): JSX.Element {
  const dispatch = useAppDispatch();
  const location = useLocation();

  const [entered, setEntered] = useState(false);

  const loading = useAppSelector((state) => state.auth.loading);
  const user = useAppSelector((state) => state.auth.user);

  const loginActions = [
    {
      icon: <TbUserCircle />,
      key: 'profile',
      label: 'Profil',
      onClick: gotoProfile,
      style: {
        color: location.pathname === '/profile' ? '#1677ff' : 'black',
      },
    },
    {
      icon: <TbCirclesRelation />,
      key: 'identity',
      label: 'Identité',
      onClick: redirectToIdentity,
    },
    {
      key: 'logout',
      label: 'Se déconnecter',
      icon: <TbLogout />,
      onClick: redirectToLogout,
    },
  ];

  function gotoProfile(): void {
    dispatch({ type: 'app/goto', payload: '/profile' });
  }

  function redirectToLogin(): void {
    dispatch(actions.login());
  }

  function redirectToLogout(): void {
    dispatch(actions.logout());
  }

  function redirectToIdentity(): void {
    window.open(process.env.REACT_APP_PROFILE_URL, '_blank');
  }

  let timeout: any;

  return (
    <div
      className='LoginButton'
      onMouseEnter={() => {
        clearTimeout(timeout);
        setEntered(true);
      }}
      onMouseLeave={() => {
        timeout = setTimeout(() => {
          setEntered(false);
        }, 500);
      }}
    >
      {user ? (
        <Dropdown.Button
          overlayClassName={entered ? 'LoginButton__Dropdown--entered' : 'LoginButton__Dropdown--left'}
          icon={<CaretDownFilled />}
          menu={{
            items: entered ? loginActions : [],
          }}
          onClick={gotoProfile}
        >
          {user.name}
        </Dropdown.Button>
      ) : (
        <Button icon={<TbLogin />} loading={loading} onClick={redirectToLogin}>
          Se connecter
        </Button>
      )}
    </div>
  );
}
